import { createContext, use } from 'react'

export type Theme = 'dark' | 'light'

type ThemeContextProps = { theme: Theme }

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined)

export const useTheme = (): ThemeContextProps => {
    const context = use(ThemeContext)

    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }

    return context
}
